/* global gv */

var servicesTranslates = {
    "Shops and Services": ["Služby a obchody"],
    "Choose category": ["Vyberte kategorii"],
    "Services detail": ["Detail místa"],
    "Map": ["Mapa"],
    "Type to Search": ["Zadejte hledaný výraz"],
    "service": ["sluzba"],
    "Back to Shops and Services": ["Zpět na služby a obchody"],
    "shops-and-service": ["obchody-a-sluzby"],

    "All": ["Vše"],
    "Restaurants & cofee": ["Restaurace a kavárny"],
    "Health & Beauty": ["Zdraví a krása"],
    "Shops": ["Obchody"],
    "Lifestyle": ["Životní styl"],
    "Services": ["Služby"],
    "Schools": ["Školy"]
};

Vue.mixin({
    methods: {
        $t: function (key) {
            if (typeof key === "undefined" || key === "") return "$t(key) - missing key";
            else if (!(key in servicesTranslates) || gv.en) return key;
            else return servicesTranslates[key][0]
        }
    }
});

/* global gv */

var services = new Vue({

    el: '#vue-services',

    data: {
        gv: gv,
        translates: servicesTranslates,
        alphabetFilter: ["all", "A-B", "C-D", "E-F", "G-H", "I-J", "K-L", "M-N", "O-P", "Q-R", "S-T", "U-V", "W-X", "Y-Z", "0-9"],
        activeCategory: "all",
        activeAlphabetCategory: "all",
        mapIsActive: false,
        searchText: "",
        selected: 0,
        data: [],
        filteredData: [],
        dataForSearch: [],
        actualDay: new Date().getDay(),
        actualHour: new Date().getHours(),
        actualMinutes: new Date().getMinutes()
    },

    methods: {

        getItems()
        {
            this.$http.get(`${gv.root_url}/api/services/4/`).then(response => {
                this.data = response.data;
                this.filteredData = this.data;
            }, response => {
                console.log('getData: Error', response.status);
            });
        },

        checkOpeningHours(text, day) {

            let getClosingHour = text.replace(/\s/g, "").split('-')[1];
            let getOpeningHour = text.replace(/\s/g, "").split('-')[0];

            getClosingHour = parseInt(getClosingHour);
            getOpeningHour = parseInt(getOpeningHour);

            if (text === "0") {
                if (gv.cs === 1) {
                    return "ZAVŘENO";
                } else {
                    return "CLOSED";
                }
            }

            if (this.actualHour > getClosingHour || this.actualHour < getOpeningHour && day === this.actualDay) {
                if (gv.cs === 1) {
                    return "NYNÍ ZAVŘENO";
                } else {
                    return "NOW CLOSED";
                }
            } else {
                return text;
            }
        },

        searchFilter() {
            let word = this.searchText.toLowerCase();
            let res;

            if (this.dataForSearch.length !== 0) {
                res = this.dataForSearch.filter(item => {
                    if (item.name.toLowerCase().indexOf(word) !== -1) {
                        return item;
                    }
                });
            } else {
                res = this.data.filter(item => {
                    if (item.name.toLowerCase().indexOf(word) !== -1) {
                        return item;
                    }
                });
            }

            this.filteredData = res;

            return this.filteredData;

        },

        initMap(serviceName) {
            let servicesMap;
            let data = this.data;
            let latlngset;
            let infoWindows = [];

            /**
             * Inicializační script pro mapu na /list-of-services
             */

            function setMarkers(map, data){
                var marker, i;

                function setMarkerIcon(category) {
                    switch(category) {
                        case "restaurants":
                            return gv.content_url + "/images/googlemaps/rest.svg";
                            break;
                        case "schools":
                            return gv.content_url + "/images/googlemaps/school.svg";
                            break;
                        case "shops":
                            return gv.content_url + "/images/googlemaps/shop.svg";
                            break;
                        case "health":
                            return gv.content_url + "/images/googlemaps/health.svg";
                        case "lifestyle":
                            return gv.content_url + "/images/googlemaps/culture.svg";
                        case "services":
                            return gv.content_url + "/images/googlemaps/services.svg";
                        default:
                            return false;
                    }
                }

                for (i = 0; i < data.length; i++) {
                    var lat = parseFloat(data[i].loc.lat);
                    var long = parseFloat(data[i].loc.lng);

                    latlngset = new google.maps.LatLng(lat, long)

                    if (serviceName === undefined) {
                        marker = new google.maps.Marker({
                            map: map, position: latlngset,
                            icon: {
                                url: setMarkerIcon(data[i].category),
                                scaledSize: new google.maps.Size(35, 35)
                            }
                        });
                    } else {
                        lat = parseFloat(serviceName.loc.lat);
                        long = parseFloat(serviceName.loc.lng);

                        latlngset = new google.maps.LatLng(lat, long)

                        marker = new google.maps.Marker({
                            map: map, position: latlngset,
                            icon: {
                                url: setMarkerIcon(serviceName.category),
                                scaledSize: new google.maps.Size(35, 35)
                            }
                        });
                    }

                    map.setCenter(marker.getPosition())

                    function serviceRoot() {
                        if (gv.cs === 1) return "sluzba"
                        else return "service"
                    }

                    let infoWindow;

                    if (serviceName === undefined) {
                        if (gv.cs === 1) {
                            infoWindow = new google.maps.InfoWindow({
                                content: `<div class="text-center"><h5 class="info-window-content">${data[i].name}</h5> <a href="/${serviceRoot()}/${data[i].slug}" class="btn btn-main">Zobrazit službu</a></div>`
                            });
                        } else {
                            infoWindow = new google.maps.InfoWindow({
                                content: `<div class="text-center"><h5 class="info-window-content">${data[i].name}</h5> <a href="/${serviceRoot()}/${data[i].slug}" class="btn btn-main">Services detail</a></div>`
                            });
                        }
                    } else {
                        if (gv.cs === 1) {
                            infoWindow = new google.maps.InfoWindow({
                                content: `<div class="text-center"><h5 class="info-window-content">${serviceName.name}</h5> <a href="/${serviceRoot()}/${serviceName.slug}" class="btn btn-main">Zobrazit službu</a></div>`
                            });
                        } else {
                            infoWindow = new google.maps.InfoWindow({
                                content: `<div class="text-center"><h5 class="info-window-content">${serviceName.name}</h5> <a href="/${serviceRoot()}/${serviceName.slug}" class="btn btn-main">Services detail</a></div>`
                            });
                        }
                    }

                    infoWindows.push(infoWindow);

                    google.maps.event.addListener(marker,'mouseover', (function(marker, infoWindow){
                        return function() {
                            for (var i=0;i<infoWindows.length;i++) {
                                infoWindows[i].close();
                            }
                            infoWindow.open(map,marker);
                        };
                    })(marker, infoWindow));
                }
            }

            function initServicesMap() {

                let container = document.getElementById('map-services');
                container.style.height = '850px';

                const mapLatLng = {lat: 50.1079576, lng: 14.4543963};

                servicesMap = new google.maps.Map(container, {
                    center: mapLatLng,
                    zoom: 14,
                    mapTypeControl: false,
                    fullscreenControl: false,
                    streetViewControl: false,
                    zoomControl: false,
                    styles: [
                        {
                            featureType: 'poi',
                            stylers: [{visibility: 'off'}]
                        },
                        {
                            featureType: 'transit',
                            elementType: 'labels.icon',
                            stylers: [{visibility: 'off'}]
                        }
                    ]
                });

                setMarkers(servicesMap, data);
            }

            initServicesMap();
        },

        filterServices(category) {
            this.activeCategory = category;

            this.updateData();
        },

        alphabetFilterServices(category, el)
        {
            this.activeAlphabetCategory = category;

            this.updateData();
        },

        updateData() {
            let dataCollector = [];

            if (this.activeCategory === "all" && this.activeAlphabetCategory === "all") {
                this.filteredData = this.data;
                return this.filteredData;
            }

            this.filteredData = this.data.filter(item => {
                if (this.activeCategory !== "all") {
                    if (item.name.slice(0,1) === this.activeAlphabetCategory.slice(2,3) && item.category === this.activeCategory) {
                        dataCollector.push(item);
                    }

                    if (item.name.slice(0,1) === this.activeAlphabetCategory.slice(0,1) && item.category === this.activeCategory) {
                        dataCollector.push(item);
                    }
                }

                if (this.activeCategory === "all") {
                    if (item.name.slice(0,1) === this.activeAlphabetCategory.slice(2,3)) {
                        dataCollector.push(item);
                    }

                    if (item.name.slice(0,1) === this.activeAlphabetCategory.slice(0,1)) {
                        dataCollector.push(item);
                    }
                }

                if (this.activeAlphabetCategory === "all") {
                    if (item.category === this.activeCategory) {
                       dataCollector.push(item);
                    }
                }

            });

            this.filteredData = dataCollector;
            this.dataForSearch = dataCollector;

            return this.filteredData;
        }
    },

    mounted() {
        this.getItems();

        $(".services-search input").on("keydown change paste input", () => {
           this.searchFilter();
        });
    },

    template:
        `
<div class="container-fluid mt-navheight pt-5 services">
    <div class="container">
        <div class="row">
            <div class="col text-center">
                <h1 class="page-header-title-secondary d-block d-lg-inline-block">{{ $t("Shops and Services") }}</h1>
            </div>
        </div>  
        <div class="row mt-4">
            <div class="col-12 d-flex justify-content-between align-items-center">
                <div class="services-control">
                    <button :class="[{ active: !mapIsActive }, 'btn-icon']" v-on:click="mapIsActive = false"><i class="fas fa-list"></i></button>
                    <button :class="[{ active: mapIsActive }, 'btn-icon']" v-on:click="mapIsActive = true; initMap();"><i class="fas fa-map-marker-alt"></i></button>
                </div>
                <div class="services-search" v-if="!mapIsActive">
                    <input type="text" :placeholder="$t('Type to Search')" class="form-control" v-model="searchText"/>
                </div>
            </div>
        </div>  
        <div :class="{ hidden: mapIsActive }">
            <div class="row mt-4 ml-0 services-alphabet-filter">
                <div class="col-12 col-xl-2"></div>
                <div class="col-12 col-xl-10 p-0 d-lg-flex justify-content-between">
                    <button v-for="(filter, index) in alphabetFilter" :key="filter" :class="{active:index == selected}"  @click="alphabetFilterServices(filter); selected = index">{{ filter }}</button>
                </div>
            </div>  
            <div class="row mt-4">
                <div class="col-12 col-lg-2 mt-4">
                    <span class="services-category-title d-block pb-1">{{ $t("Choose category") }}</span>
                    <div class="custom-control custom-radio custom-control-inline d-block mt-2">
                      <input type="radio" id="all" name="category-filter" class="custom-control-input" checked>
                      <label class="custom-control-label" for="all" v-on:click="filterServices('all')" checked>{{ $t('All') }}</label>
                    </div>
                    <div class="custom-control custom-radio custom-control-inline d-block mt-2">
                      <input type="radio" id="restaurants" name="category-filter" class="custom-control-input">
                      <label class="custom-control-label" for="restaurants" v-on:click="filterServices('restaurants')">{{ $t('Restaurants & cofee') }}</label>
                    </div>
                    <div class="custom-control custom-radio custom-control-inline d-block mt-2">
                      <input type="radio" id="health" name="category-filter" class="custom-control-input">
                      <label class="custom-control-label" for="health" v-on:click="filterServices('health')">{{ $t('Health & Beauty') }}</label>
                    </div>
                    <div class="custom-control custom-radio custom-control-inline d-block mt-2">
                      <input type="radio" id="shops" name="category-filter" class="custom-control-input">
                      <label class="custom-control-label" for="shops" v-on:click="filterServices('shops')">{{ $t('Shops') }}</label>
                    </div>
                    <div class="custom-control custom-radio custom-control-inline d-block mt-2">
                      <input type="radio" id="lifestyle" name="category-filter" class="custom-control-input">
                      <label class="custom-control-label" for="lifestyle" v-on:click="filterServices('lifestyle')">{{ $t('Lifestyle') }}</label>
                    </div>
                    <div class="custom-control custom-radio custom-control-inline d-block mt-2">
                      <input type="radio" id="services" name="category-filter" class="custom-control-input">
                      <label class="custom-control-label" for="services" v-on:click="filterServices('services')">{{ $t('Services') }}</label>
                    </div>       
                    <div class="custom-control custom-radio custom-control-inline d-block mt-2">
                      <input type="radio" id="schools" name="category-filter" class="custom-control-input">
                      <label class="custom-control-label" for="schools" v-on:click="filterServices('schools')">{{ $t('Schools') }}</label>
                    </div>                            
                </div>
                <div class="col-12 col-lg-10">
                    <div class="row">
                        <div class="col-12 col-md-6 col-lg-4 col-xl-3 mt-4" v-for="service in filteredData" :key="service.name">
                            <div class="services-item text-center">
                                <img :src="gv.content_url + '/files/Products/product_' + service.id + '/' + service.logo"/>
                                <h5 class="mt-2 mb-4 services-item-name">{{ service.name }}</h5>
                                <span v-if="service.openingHoursExtended !== ''">  
                                    <i class="far fa-clock"></i>
                                    {{ checkOpeningHours(service.openingHoursExtended[1][actualDay], actualDay) }}
                                </span>
                                <span style="padding-left: 15px;" v-else>NYNÍ ZAVŘENO</span>
                                <div class="mt-2">
                                    <a :href="'/' + $t('service') + '/' + service.slug" class="btn btn-main btn-small text-uppercase">{{ $t("Services detail") }}</a>
                                </div>
                                <div class="mt-2">
                                    <a href="#" class="btn btn-main btn-small text-uppercase" v-on:click="mapIsActive = true; initMap(service);">{{ $t("Map") }}</a>
                                </div>
                            </div>  
                        </div>                  
                    </div>
                </div>     
             </div>           
        </div>
        <div :class="{ hidden: !mapIsActive }">
            <div class="col-12 mt-4" id="map-services"></div> 
        </div>
    </div>
</div>
`
});
